import Api from '~/api'
import { push } from 'react-router-redux'
import { Map, List, fromJS } from 'immutable'
import { resetForm, formSuccess, isLoading, formError } from '~/form/actions'
import { registerEvents } from '~/event/actions'

export function createTask(formId, task) {
  return async (dispatch, getState) => {
    try {
      let { data } = await Api.post('/task', { task })

      if (data.success) {
        dispatch(createTaskSuccess(data.item))
        dispatch(resetForm(formId))
      }

      if (Array.isArray(data.updatedTasks))
        dispatch({
          type: 'TASK_BATCH_UPDATE',
          items: data.updatedTasks,
        })

      if (data.message) dispatch(formError({ messages: [data.message] }))
    } catch (error) {
      dispatch(formError({ messages: [err.message || 'Error when creating task'] }))
    }
  }
}

export function createTaskSuccess(item) {
  return {
    type: 'TASK_CREATE_SUCCESS',
    table_id: 'tasks',
    item,
  }
}

/* Edit task */

export function editTask(formId, id, values) {
  return async dispatch => {
    try {
      let { data } = await Api.patch(`/task/${id}`, { values })

      dispatch(registerEvents(data.events))

      if (data.success) {
        dispatch(editTaskSuccess(data.item))
        dispatch(resetForm(formId))
      }

      if (data.message) dispatch(formError({ messages: [data.message] }))

      if (Array.isArray(data.updatedTasks))
        dispatch({
          type: 'TASK_BATCH_UPDATE',
          items: data.updatedTasks,
        })
    } catch (err) {
      console.log(err)
      dispatch(formError({ messages: [err.message] }))
    }

    dispatch(isLoading(formId, false))
  }
}

export function editTaskLoading(loading) {
  return {
    type: 'TASK_EDIT_LOADING',
    loading,
  }
}

export function editTaskSuccess(item) {
  return {
    type: 'TASK_EDIT_SUCCESS',
    table_id: 'tasks',
    item,
  }
}

export function editTaskError(message) {
  return {
    type: 'TASK_EDIT_ERROR',
    message,
  }
}

/* Edit task */

export function deleteTask(formId, id) {
  return async dispatch => {
    try {
      let { data } = await Api.delete(`/task/${id}`)

      dispatch(registerEvents(data.events))

      if (data.success) {
        dispatch(deleteTaskSuccess(id, data.task))
        dispatch(resetForm(formId))
      }

      if (data.message) dispatch(formError({ messages: [data.message] }))

      if (Array.isArray(data.updatedTasks))
        dispatch({
          type: 'TASK_BATCH_UPDATE',
          items: data.updatedTasks,
        })
    } catch (err) {
      console.log(err)
      dispatch(formError({ messages: [err.message] }))
    }

    dispatch(isLoading(formId, false))
  }
}

export function deleteTaskLoading(loading) {
  return {
    type: 'TASK_DELETE_LOADING',
    loading,
  }
}

export function deleteTaskSuccess(item_id, item) {
  return {
    type: 'TASK_DELETE_SUCCESS',
    table_id: 'tasks',
    item_id,
    item,
  }
}

export function deleteTaskError(message) {
  return {
    type: 'TASK_DELETE_ERROR',
    message,
  }
}

/* Fetch tasks */

export function fetchTasks(config = {}) {
  return dispatch => {
    dispatch(fetchTasksLoading(true))
    Api.get('/task', config)
      .then(({ data }) => {
        if (data.success) return dispatch(fetchTasksSuccess(data.items))

        if (data.message) return dispatch(fetchTasksError(data.message))
      })
      .finally(() => dispatch(fetchTasksLoading(false)))
  }
}

export function fetchTasksLoading(loading = true) {
  return {
    type: 'TASKS_FETCH_LOADING',
    loading,
  }
}

export function fetchTasksSuccess(items) {
  return {
    type: 'TASKS_FETCH_SUCCESS',
    items,
  }
}

export function fetchTasksError(message) {
  return {
    type: 'TASKS_FETCH_ERROR',
    message,
  }
}
